import React from "react"
import map from "lodash/map"
import { format } from "date-fns"
import {
    HorizontalStackSpaceBetween,
    TextBold,
    TextSmall,
} from "@mallardbay/lib-react-components"

import { formatPrice } from "~utils/helpers"
import { DATE_FORMAT_SLASH } from "~utils/date-helpers"
import type { QuotePaymentPlanFieldsFragment } from "~graphql/generated/graphql"
import SmallTextSkeleton from "~components/shared/small-text-skeleton"
import COPY from "~config/copy-constants"

export interface Props {
    readonly paymentPlan: QuotePaymentPlanFieldsFragment
    readonly isDueNow?: boolean
    readonly isLoading?: boolean
}

export default function QuotePaymentPlanSummary({
    paymentPlan,
    isDueNow = false,
    isLoading,
}: Props) {
    return (
        <>
            {map(paymentPlan.payments, (payment, idx) => (
                <HorizontalStackSpaceBetween key={payment.id}>
                    <TextSmall>
                        {getPaymentLabel({
                            isDueNow,
                            paymentDate: payment.date,
                            paymentOrder: idx,
                        })}
                    </TextSmall>
                    {isLoading ? (
                        <SmallTextSkeleton />
                    ) : (
                        <TextBold>{formatPrice(payment.value)}</TextBold>
                    )}
                </HorizontalStackSpaceBetween>
            ))}
        </>
    )
}

function getFirstPaymentLabel(isDueNow: boolean) {
    return isDueNow ? COPY.DUE_NOW : COPY.DUE_AFTER_CONFIRMATION
}

function getFuturePaymentLabel(date: number) {
    return `${COPY.DUE_ON} ${format(date, DATE_FORMAT_SLASH)}`
}

function getPaymentLabel({
    isDueNow,
    paymentDate,
    paymentOrder,
}: {
    isDueNow: boolean
    paymentDate: number
    paymentOrder: number
}) {
    return paymentOrder === 0
        ? getFirstPaymentLabel(isDueNow)
        : getFuturePaymentLabel(paymentDate)
}
